import styled from "styled-components";

export const AchievementProgressStyled = styled.div`
    margin-bottom: 16px;
`;

export const AchievementProgressItemStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    padding: 16px;
    border-radius: var(--border-radius);
    background-color: var(--color-background-secondary);
    box-shadow: var(--shadow-primary);

    transition: all 500ms ease 0s;
    margin: 0 4px;

    img {
        max-width: 40px;
        max-height: 40px;
    }
`;

export const AchievementProgressCarouselStyled = styled.div`
    margin: 0 -16px;

    .carousel.carousel-slider .slider-wrapper {
        padding: 0 12px;
        margin: 0;
    }

    .carousel.carousel-slider, .carousel.carousel-slider .slider-wrapper {
        overflow: unset;
    }
`;